module.exports = __webpack_public_path__ + "img/banner.9c0b9604.webp";